import { Directive, ElementRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { xssValidator } from './xss-validator';

@Directive({
  selector: '[appXssValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: XssValidatorDirective,
    multi: true
  }]
})
export class XssValidatorDirective implements Validator {
  private validator: ValidatorFn;

  constructor(private elementRef: ElementRef) {
    this.validator = xssValidator();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return  this.validator(control);     
  }
}
